var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolMembershipSubManagement01 = function SvgSolMembershipSubManagement01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_membership_sub_management-01_svg2__a",
    x1: 25.64,
    x2: 154.39,
    y1: 175.82,
    y2: -22.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__b",
    x1: 37.72,
    x2: 166.47,
    y1: 183.67,
    y2: -14.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__c",
    x1: 49.81,
    x2: 178.56,
    y1: 191.52,
    y2: -6.69
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__d",
    x1: -4.47,
    x2: 124.29,
    y1: 156.27,
    y2: -41.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__e",
    x1: 7.62,
    x2: 136.37,
    y1: 164.12,
    y2: -34.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__f",
    x1: 46.73,
    x2: 175.49,
    y1: 189.52,
    y2: -8.69
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__g",
    x1: 58.82,
    x2: 187.57,
    y1: 197.37,
    y2: -0.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__h",
    x1: 4.54,
    x2: 133.3,
    y1: 162.12,
    y2: -36.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__i",
    x1: 16.63,
    x2: 145.38,
    y1: 169.97,
    y2: -28.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__j",
    x1: 28.71,
    x2: 157.46,
    y1: 177.82,
    y2: -20.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__k",
    x1: 41.37,
    x2: 170.12,
    y1: 186.04,
    y2: -12.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_membership_sub_management-01_svg2__a",
    id: "sol_membership_sub_management-01_svg2__l",
    x1: 109.81,
    x2: 238.56,
    y1: 230.5,
    y2: 32.29
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97.53 61.5h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.09c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13V67.8c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.53 87.95h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.09c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13v-9.79c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.53 114.41h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.08c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13v-9.79c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.54 87.95h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.09c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13v-9.79c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.54 114.41h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.08c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13v-9.79c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.72 83.89h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29m-2.13-16.09c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13v9.79c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.82 104.04v-9.79c0-3.47-2.82-6.29-6.29-6.29h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29m-4.17 0c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13v-9.79c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54 61.5h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.09c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13V67.8c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54 87.95h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.09c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13v-9.79c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54 114.41h-9.81c-3.47 0-6.29 2.82-6.29 6.29v9.79c0 3.47 2.82 6.29 6.29 6.29h9.81c3.47 0 6.29-2.82 6.29-6.29v-9.79c0-3.47-2.82-6.29-6.29-6.29m2.13 16.08c0 1.17-.95 2.13-2.13 2.13h-9.81c-1.17 0-2.13-.95-2.13-2.13v-9.79c0-1.17.95-2.13 2.13-2.13h9.81c1.17 0 2.13.95 2.13 2.13z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77 164.79c-4.05-1.84-6.67-5.89-6.67-10.32s2.62-8.53 6.67-10.36c.92-.42 1.41-1.44 1.16-2.43-.92-3.52-2.35-7.01-4.25-10.37-.5-.9-1.58-1.29-2.55-.93-4.18 1.57-8.91.56-12.04-2.58s-4.15-7.86-2.58-12.04c.36-.96-.03-2.04-.93-2.55-3.36-1.9-6.85-3.33-10.38-4.25a2.1 2.1 0 0 0-2.43 1.16 11.33 11.33 0 0 1-9.54 6.61V23.87c0-6.03-4.91-10.94-10.94-10.94h-15.06V9.28c.02-5.11-4.14-9.28-9.26-9.28s-9.28 4.16-9.28 9.28v3.65H44.57V9.28c0-5.11-4.16-9.28-9.28-9.28s-9.28 4.16-9.28 9.28v3.65H10.94C4.91 12.93 0 17.84 0 23.87v126.21c0 6.03 4.91 10.94 10.94 10.94h103.69c-1.14 1.6-2.67 2.92-4.51 3.78-.93.43-1.41 1.47-1.13 2.46 1.02 3.6 2.43 7.05 4.18 10.27.49.9 1.57 1.31 2.53.96 4.31-1.55 8.95-.55 12.11 2.61 3.12 3.12 4.13 7.87 2.57 12.09-.36.97.05 2.06.97 2.56a51.5 51.5 0 0 0 10.3 4.18c1.01.28 2.04-.22 2.46-1.13 1.86-4.04 5.93-6.64 10.37-6.64s8.5 2.6 10.32 6.63a2.09 2.09 0 0 0 2.43 1.16c3.47-.91 6.95-2.32 10.36-4.2.9-.5 1.31-1.58.95-2.55-1.57-4.21-.56-8.95 2.58-12.08 3.13-3.12 7.86-4.15 12.05-2.61.94.35 2.02-.04 2.52-.92 1.76-3.08 3.15-6.45 4.24-10.3.28-.99-.21-2.04-1.15-2.47ZM114.86 9.28c0-2.82 2.29-5.11 5.11-5.11s5.11 2.29 5.11 5.11v11.49c0 2.82-2.29 5.11-5.11 5.11s-5.11-2.29-5.11-5.11zm-84.68 0c0-2.82 2.29-5.11 5.11-5.11s5.11 2.29 5.11 5.11v11.49c0 2.82-2.29 5.11-5.11 5.11s-5.11-2.29-5.11-5.11zM10.94 156.85c-3.73 0-6.77-3.04-6.77-6.77V23.87c0-3.73 3.04-6.77 6.77-6.77h15.07v3.67c0 5.12 4.16 9.28 9.28 9.28s9.28-4.16 9.28-9.28V17.1h66.12v3.67c0 5.12 4.16 9.28 9.28 9.28s9.28-4.16 9.28-9.28V17.1h15.06c3.73 0 6.77 3.04 6.77 6.77v92.4c-3.04-.95-5.62-3.15-6.97-6.14-.25-.55-.72-.91-1.26-1.09V51.75c0-1.15-.93-2.08-2.08-2.08H14.5c-1.15 0-2.08.93-2.08 2.08v94.79c0 1.15.93 2.08 2.08 2.08h100.62c1.04 1.74 1.64 3.75 1.64 5.84 0 .81-.12 1.61-.29 2.38H10.94Zm119.44-41.1c1.58 4.27.59 8.88-2.57 12.05-3.17 3.17-7.8 4.15-12.09 2.57-.96-.35-2.04.05-2.55.95-1.88 3.42-3.3 6.9-4.2 10.36-.25.98.23 2 1.14 2.42.22.1.43.24.64.36H16.58V53.83h122.1v56.08c-2.64.92-5.08 2.01-7.38 3.3a2.08 2.08 0 0 0-.93 2.54Zm62.46 58.3c-5.23-1.26-10.85.26-14.69 4.1-3.85 3.85-5.36 9.46-4.08 14.72-2.1 1.06-4.22 1.92-6.33 2.58-2.77-4.59-7.8-7.47-13.27-7.47s-10.48 2.87-13.29 7.45c-2.18-.7-4.31-1.57-6.36-2.58 1.27-5.26-.24-10.87-4.08-14.7-3.82-3.82-9.43-5.34-14.7-4.1a45 45 0 0 1-2.57-6.33c3.01-1.85 5.27-4.66 6.47-7.91.03-.06.04-.13.07-.19.58-1.63.92-3.36.92-5.14 0-5.45-2.88-10.49-7.47-13.3.66-2.11 1.52-4.24 2.58-6.35 5.27 1.27 10.88-.24 14.72-4.07 3.89-3.9 5.38-9.39 4.07-14.69 1.97-1 4.07-1.86 6.35-2.59 2.79 4.6 7.83 7.49 13.3 7.49s10.49-2.9 13.27-7.51c2.13.66 4.25 1.53 6.33 2.6-1.29 5.24.22 10.84 4.08 14.69 3.85 3.85 9.45 5.36 14.69 4.08 1.07 2.08 1.94 4.2 2.6 6.33-4.61 2.79-7.51 7.83-7.51 13.31s2.89 10.48 7.49 13.26c-.73 2.28-1.58 4.37-2.58 6.32Z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44 154.76a13 13 0 0 0 4-9.38c0-7.19-5.85-13.05-13.05-13.05s-13.05 5.85-13.05 13.05c0 3.69 1.54 7.02 4.01 9.39-4.67 2.16-8.52 5.95-10.67 10.7-2.32 5.14 1.55 10.98 7.23 10.98h24.96c5.68 0 9.55-5.84 7.23-10.95-2.13-4.78-5.99-8.58-10.67-10.74Zm-9.05-18.26c4.9 0 8.88 3.98 8.88 8.88s-3.99 8.88-8.88 8.88-8.88-3.99-8.88-8.88c0-4.9 3.98-8.88 8.88-8.88m12.48 35.79h-24.96c-2.62 0-4.52-2.7-3.43-5.1 2.13-4.72 6.34-8.27 11.3-9.62 1.44.54 2.98.86 4.61.86s3.18-.31 4.62-.86c4.98 1.35 9.18 4.9 11.29 9.65 1.1 2.41-.83 5.08-3.43 5.08Z",
    style: {
      fill: "url(#sol_membership_sub_management-01_svg2__l)"
    }
  }));
};
export default SvgSolMembershipSubManagement01;